<template>
  <BasicTooltip
    v-if="isNotAllowed"
    :label
    :position="toolTipPosition"
  >
    <slot :isNotAllowed="isNotAllowed" />
  </BasicTooltip>
  <slot v-else :isNotAllowed="isNotAllowed" />
</template>

<script lang="ts" setup>
  import type { WrapperPermissionsProps } from './WrapPermissions.types'
  import { useAppStateStore } from '@/features/application'
  import { computed } from 'vue'

  const props = withDefaults(defineProps<WrapperPermissionsProps>(), {
    toolTipPosition: 'bottom',
    label: "Vous n'êtes pas autorisé à effectuer cette action",
  })

  const appState = useAppStateStore()

  const isAllowed = computed(() =>
    (Array.isArray(props.permissions) ? props.permissions : [props.permissions])
      .some((p) => appState.autoriseEcriture(p))
  )

  const isNotAllowed = computed(() => !isAllowed.value)
</script>
